<template>
<div class="">
  <div class="bodyer_right" :style="bodyerstyle">
    <div class="titleview">
      <titleview title="实时捐助" icon="fengche" color=""></titleview>
    </div>
    <div class="bodyer_right_box oftbox">
      <div class="li" v-for="(item, index) in list" :key="index">
        <div class="headerimg"></div>
        <div class="deahline">
          <div class="name">
            <!--  "在" +  item.activityId_dictText + 项目-->
            <span>{{item.donationUserId.substring(0,8)}}</span>
            <span v-if="item.donationUserId.length > 8">...</span>
            <span v-if='item.money'>
              捐助 <span style="color:#E41E15;">￥</span>{{getFormatMoney(item.money)}}元
            </span>
          </div>
          <div class="date">{{ item.donationDate }}</div>
        </div>
      </div>
    </div>
  </div>
 </div> 
</template>

<script>
import { formatMoney } from '@/utils/util'
export default {
   props: {
	  bodyerstyle: {
	    type: String
	  }
   },
  data() {
    return {
		list: [],
		startTime: "", 
		endTime: "",
		donationUserId: "",
		  
    };
  },
  methods: {
	searchclick(start,stop,username) {
	    console.log(start+" "+stop+" "+username)
		this.startTime = start;
		this.endTime = stop;
		this.donationUserId = username;
		this.init()
	},
			
    init() {
      //web/donation/thpDonationRecord/list
      // {
      //     startTime:this.startTime,
      //     endTime:this.endTime,
      //     donationUserId:this.donationUserId,
      //     pageNo: 1,
      //     pageSize: 10
      // }
      var that = this;
      this.httpGet("/web/donation/thpDonationRecord/donationTime").then(res => {
          that.list = res.result;
      });
		
    },
    getFormatMoney(money){
      return formatMoney(money,0)
    },
  },
  mounted() {},
  created() {
    this.init();
  }
};
</script>

<style scoped="scoped" lang="scss">
.titleview {
  height: 38px;
  background: #e41e15;
  width: 100%;
}
.bodyer_right {
  width: 440px;
  height: 410px;
  padding: 0;
  margin: 0;
  background: #ffffff;
  overflow: hidden;
}
.bodyer_right_box {
  border: 1px solid #ededed;
  height: 372px;
  .title {
    font-size:14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #99a0ac;
    line-height:24px;
    margin:13px auto 24px 19px;
    overflow: hidden;
    .icon {
      width:18px;
      height:24px;
      background: url(../assets/wx.png) no-repeat center/100% 100%;
      float: left;
    }
    .date1 {
      float: left;
      margin-left: 10px;
    }
  }
  .li {
    overflow: hidden;
    color: #666666;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    position: relative;
    .headerimg {
      width: 12px;
      height: 12px;
      background: #ffffff;
      float: left;
      margin: 17px 0 0 20px;
      background: url(../assets/lingxing.png) no-repeat center / 100% 100%;
    }
    .deahline {
	    cursor: default;
      width: 380px;
      height: 46px;
      line-height:46px;
      float: left;
      margin-left:8px;
      border-bottom:1px dotted #ededed;
      overflow: hidden;
    }
    .name {
	    font-size:14px;
      float: left;
    }
    .date {
	    font-size:14px;
      float: right;
      margin-right:2px;
    }
  }
  .li:hover {
    color: #E41E15!important;
  }
}
</style>
